import React from "react";
import ServicesPage from "./common/ServicesPage";
import HowDsWork from "./HowDsWork";
import { Heading } from "@chakra-ui/react";
const DemolitionServices = () => {
  return (
    <div>
      <></>
      <ServicesPage
      title={
          <Heading
            as="h1"
            textAlign="center"                     // Center text
            px={{ base: 4, md: 8 }}               // Responsive horizontal padding
            fontSize={{ base: "xl", md: "2xl" }} // Responsive font size
            className="services-title"
          >
            Demolition Done Safely
          </Heading>
        }
    
     image="/baner (2).png"
        description={
          <>
            <p>
              Our <strong>Demolition Services</strong> are designed to meet the
              highest standards of safety and efficiency. Whether you require
              partial demolition, complete site clearance, or selective removal
              of structures, our expert team ensures that every project is
              handled with precision. With years of experience, we have worked
              on both residential and commercial properties, delivering reliable
              results that keep projects on schedule and within budget.
            </p>

            <p style={{ marginTop: "1rem" }}>
              We use modern equipment and follow strict safety protocols to
              minimize risk and environmental impact. Our team is trained to
              manage projects of all sizes—ranging from small houses to large
              industrial sites—while ensuring compliance with local regulations
              and eco-friendly practices. We also handle debris removal and
              waste management, leaving your site ready for the next phase of
              construction.
            </p>

            <ul  color="#FF4D00" style={{ marginTop: "1rem", paddingLeft: "1.2rem" }}>
              <li> Safe and controlled demolition techniques</li>
              <li> Residential and commercial projects</li>
              <li> Waste disposal and site cleanup</li>
              <li> Experienced, certified professionals</li>
            </ul>

            <p style={{ marginTop: "1rem" }}>
              Choosing our demolition services means choosing reliability,
              safety, and professionalism. We don’t just demolish—we prepare the
              foundation for your new beginning.
            </p>
              <HowDsWork/>
          </>
        
        }
        
      />
      
    </div>
  );
};

export default DemolitionServices;
